const key = '38dae57844fe4124877ce96194367bc8';
const imageSrvURL = `${imageSrv}/imagesrv/imp_getimage`;

export function getHost(hostname, proplist) {
    const p = proplist ? proplist : 'bustandcup,asssize,buildid,aboutme,photosjson';
    return fetch(`https://gstsvc.webcamwiz.com/imlapi_get_statsonlineinfo/v/2015-01-01/format/json/?proplist=${p}&key=${key}&hostname=${hostname}`);
}

export function getHostImage(fn, mtcr, wi, hi) {
    
    const params = new URLSearchParams();
    
    if (mtcr != null) params.append("mtcr", mtcr);
    if (wi != null) params.append("wi", wi);
    if (hi != null) params.append("hi", hi);

    return `${imageSrvURL}?qu=77&cctrl=public,max-age%3d2592000&is=IMLFOH&wm=0&fn=${fn}&${params.toString()}`;
}

export function getHostVideo(hostname) {
    return fetch(`https://gstsvc.webcamwiz.com/get_host_free_videos/v/2015-01-01/format/json?subscription-key=${key}&hostname=${hostname}`);
}

export function getHostList(queryid = 197, proplist = null) {
    let imageRatio, imageMinSize;
    if (window.innerWidth > window.innerHeight) {
        imageRatio = '1.23,1.43';
        imageMinSize = '1024';
    } else {
        imageRatio = '0.1,0.99';
        imageMinSize = '720'
    }
    const p = proplist ? proplist : 'publicphotos,boshserver,webrtcdata';
    //return fetch(`https://gstsvc.webcamwiz.com/imlapi_get_hostlist/v/2015-01-01/format/json/?proplist=hostpromovideo&lngproplist=roomlocationid,mood,hhactivityid&ipcountry=IL&ipregion=05&ipcity=bat%20yam&ipcountrycode=30&ipregioncode=1645&ipcitycode=24600&nse=1&stid=1&studioid=0&ispayingguest=0&pimage=1&lngid=1&filter=needtotal~1@imageminsize~${imageMinSize},1@imageratio~${imageRatio}@top~50@ip~192.118.133.32@origin~2,81@roomid~10@tophostid~0@sortdef~amixflcscore@freevc~0@lngontop~0&local=0&enablespot=1&useboxes=1&domain=imlive.com&usertype=1&devicetype=1&pushadv=0,9,6,ConvertFLC,2,creditgroups,8&__command__=app_gethostlist&key=${key}`);
    return fetch(`https://gstsvc.webcamwiz.com/imlapi_get_hostlist/v/2015-01-01/format/json/?isnse=0&filter=freevc~4@sortdef~ConvertFLC@top~50@imageminsize~${imageMinSize},1@imageratio~${imageRatio}@queryid~${queryid}&proplist=${p}&notnull=publicphotos&less=gcount~10&key=${key}`);
}